// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sg div {\n  display: block !important;\n}\n.grey {\n  color: #c6c6c6;\n}", ""]);
// Exports
module.exports = exports;
